/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/assassinate': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M17 16a1 1 0 11-2 0 1 1 0 112 0zm-.5-11.9V11h-1V4.1h1zM11 16.5H4.1v-1H11v1zm4.5 11.4V21h1v6.9h-1zM21 16.5v-1h6.9v1H21z"/><path pid="1" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/>'
  }
})
